import type { AlertTokens } from './types';

export const alert: AlertTokens = {
  radii: {
    default: 'regular',
  },
};
